import React from "react";

const AddOn = ({ onAddCredits, blenderCredits }) => {
  const noDetails = blenderCredits === undefined;
  return (
    <section className="add-on">
      <div className="addon-type">
        <p>Add-On</p>
        <button className="add-credits" onClick={onAddCredits}>
          Add Credits
        </button>
      </div>
      <h2 className="heading">Team Blender Credits</h2>
      <p className="info">
        {`Team Blender credits allow to you to invite your team to your own premium virtual event. Add credits to create events as needed. 
        ${noDetails ? "" : "Blender credits are also "}`}
        {!noDetails && (
          <span onClick={() => window.open("https://heylime.com/pricing/")}>
            included in Perform and Enterprise plans
          </span>
        )}
      </p>
      <p className="credit">
        Current Credits:{" "}
        <span>{`${noDetails ? "0" : blenderCredits} Credits`}</span>
      </p>
      <p className="credit">
        Credit Price: <span>$125 per credit</span>
      </p>
    </section>
  );
};

export default AddOn;
